module.exports = __webpack_public_path__ + "img/23.12a89b57.png";